var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendersurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_735_5467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04187 1H1.95813C1.70419 1.00057 1.46082 1.1017 1.28126 1.28126C1.10169 1.46082 1.00057 1.7042 1 1.95814V9.04187C1.00057 9.29581 1.10169 9.53918 1.28126 9.71874C1.46082 9.8983 1.70419 9.99943 1.95813 10H9.04187C9.29581 9.99943 9.53918 9.8983 9.71874 9.71874C9.89831 9.53918 9.99943 9.29581 10 9.04187V1.95814C9.99943 1.7042 9.89831 1.46082 9.71874 1.28126C9.53918 1.1017 9.29581 1.00057 9.04187 1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.733333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82886 4.71777H5.19878",
    stroke: "black",
    strokeWidth: 0.733333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82886 6.76318H7.95995",
    stroke: "black",
    strokeWidth: 0.733333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.05835 0.223389V2.41445",
    stroke: "black",
    strokeWidth: 0.733333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94165 0.223389V2.41445",
    stroke: "black",
    strokeWidth: 0.733333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_735_5467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendersurvey);
export default __webpack_public_path__ + "static/media/calendersurvey.b6493153be670118ae97065801f7fe0d.svg";
export { ForwardRef as ReactComponent };